import { render, staticRenderFns } from "./PermissionChecker.vue?vue&type=template&id=47fd6f30&"
import script from "./PermissionChecker.ts?vue&type=script&lang=ts&"
export * from "./PermissionChecker.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports